<template>
  <v-card flat>
    <v-card-text class="text-xs-center">
      <v-container fluid grid-list-md>
        <v-layout wrap v-if="!result">
          <v-flex xs12 sm12 md4 offset-md4>
            <v-text-field v-model="amount"
                          name="amount"
                          :label="label"
                          v-validate="`required|min_value:1|max_value:${maxAmount}`"
                          :error-messages="errors.collect('amount')"
                          data-vv-name="amount"
                          :data-vv-as="$t('attrs.amount')"
                          required
                          persistent-hint
                          :hint="chargeHint"
                          mask="####"
                          prefix="$"
                          ></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 md4 offset-md4>
            <v-btn color="primary" @click="generate" :loading="loading">
              {{ $t('generateReference') }}
            </v-btn>
          </v-flex>

          <v-flex xs12 sm12 md4 offset-md4>
            <img src="/openpay_color.png" width="100" alt="">
            <br>
            <img src="/spei.png" width="120" alt="">
            <br>
            <a :href="termsAndConditions.value" target="_blank" v-if="hasTermsAndConditions"> {{ $t('termsAndConditions') }} </a>
          </v-flex>
        </v-layout>

        <v-layout wrap v-if="result">
          <v-flex xs12 sm12 md4 offset-md3 class="text-xs-left">
            <h2>Fecha límite de pago</h2>
            <p>{{ result.due_date | date('LL') }}</p>
            <h2>Beneficiario:</h2>
            <p>{{ $auth.currentUser.fullname }}</p>
          </v-flex>

          <v-flex xs12 sm12 md3 offset-md3 class="text-xs-left">
            <h2>Detalles de la compra</h2>
            <p>Descripción: {{ result.description }}</p>
            <p>Fecha y hora: {{ result.creation_date | date('LLL') }}</p>
          </v-flex>

          <v-flex xs12 sm12 md4 offset-md3 class="text-xs-left">
            <h2>Pasos para realizar el pago</h2>
          </v-flex>

          <v-flex xs12 sm12 md3 offset-md3 class="text-xs-left">
            <h4>Desde BBVA</h4>
            <p>1. Dentro del menú de "Pagar" seleccione la opción "De Servicios" e ingrese el siguiente "Número de convenio CIE"</p>
            <h4>Número de convenio CIE: <small>{{ result.payment_method.agreement }}</small></h4>
            <p>2. Ingrese los datos de registro para concluir con la operación.</p>
            <h4>: <small>{{ result.payment_method.name }}</small></h4>
            <h4>Importe: <small>{{ result.amount | currency }} {{ result.currency }}</small></h4>
            <h4>Concepto: <small>{{ result.description }}</small></h4>
          </v-flex>

          <v-flex xs12 sm12 md3 class="text-xs-left">
            <h4>Desde cualquier otro banco</h4>
            <p>1. Ingresa a la sección de transferencias y pagos o pagos a otros bancos y proporciona los datos de la transferencia:</p>
            <h4>Beneficiario: <small>{{ $auth.currentUser.fullname }}</small></h4>
            <h4>Banco destino: <small>{{ result.payment_method.bank }}</small></h4>
            <h4>Clabe: <small>{{ result.payment_method.clabe }}</small></h4>
            <h4>Concepto de pago: <small>{{ result.payment_method.name }}</small></h4>
            <h4>Referencia: <small>{{ result.payment_method.agreement }}</small></h4>
            <h4>Importe: <small>{{ result.amount | currency }} {{ result.currency }}</small></h4>
          </v-flex>

          <v-flex xs12 sm12 md4 offset-md4>
            <v-btn color="primary" :href="pdfLink" target="_blank">
              {{ $t('downloadInstructions') }}
            </v-btn>

            <v-btn color="primary" @click="newReference">
              {{ $t('generateNewReference') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Openpay from '@/client/openpay'

export default {
  name: 'AddFundsOpenpayBankComp',

  props: {
    settings: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      loading: false,
      amount: 0,
      result: null
    }
  },

  components: {
  },

  computed: {
    label () {
      const maxAmountFmt = this.$options.filters.currency(this.maxAmount, { precision: 0 })
      return `Monto (Máximo ${maxAmountFmt}  por transacción)`
    },

    maxAmount () {
      const setting = this.settings.find(o => o.key === 'openpay_max_amount')
      if (setting) { return Number(setting.value) }

      return 0
    },

    termsAndConditions () {
      return this.settings.find(o => o.key === 'terms_conditions') || {}
    },

    hasTermsAndConditions () {
      return !!(this.termsAndConditions || {}).value
    },

    dashboardPath () {
      if (process.env.VUE_APP_OPENPAY_ENV === '1') {
        return 'https://sandbox-dashboard.openpay.mx'
      } else {
        return 'https://dashboard.openpay.mx'
      }
    },

    merchantId () {
      const setting = this.settings.find(o => o.key === 'openpay_id')
      if (setting) { return setting.value }

      return ''
    },

    chargeHint () {
      if (!this.amount) { return '' }

      const amount = 8 * 1.16
      return `Al pagar por este medio se te cobra $${amount} de la transacción`
    },

    pdfLink () {
      if (!this.result) { return '' }
      if (!this.result.id) { return '' }

      return `${this.dashboardPath}/spei-pdf/${this.merchantId}/${this.result.id}`
    }
  },

  methods: {
    async generate () {
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }

      this.loading = true
      try {
        this.result = await Openpay.create({
          payment_method: 'bank',
          amount: this.amount
        })
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    newReference () {
      this.amount = 0
      this.result = null
    }
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
